import { useState } from "react";
import { useAdminEmailMessages } from "../../hooks/useAdminEmailMessages";
import type { AdminEmailMessage, AdminEmailReaderProps } from "../../models/admin-email.models";
import AdminEmailDailyVolume from "./AdminEmailDailyVolume";
import AdminEmailMessageList from "./AdminEmailMessageList";
import AdminEmailSelectedMessage from "./AdminEmailSelectedMessage";

// Own one inbox's selection and page history for the lifetime of the mounted reader.
// Switching inboxes or refreshing remounts this boundary, aborting old requests and clearing message content.
const AdminEmailReader = ({ mailbox }: AdminEmailReaderProps) => {
  const messages = useAdminEmailMessages(mailbox.id);
  const [selectedMessageId, setSelectedMessageId] = useState<string | null>(null);

  const selectMessage = (message: AdminEmailMessage) => setSelectedMessageId(message.id);
  const previousPage = () => {
    setSelectedMessageId(null);
    messages.previousPage();
  };
  const nextPage = () => {
    setSelectedMessageId(null);
    messages.nextPage();
  };

  return (
    <div data-test="admin-email-reader" className="min-w-0 space-y-5">
      <AdminEmailDailyVolume mailboxId={mailbox.id} />
      <div className="grid min-w-0 overflow-hidden rounded border border-gray-200 lg:grid-cols-[minmax(260px,0.9fr)_minmax(0,1.4fr)] dark:border-gray-700">
        <AdminEmailMessageList
          response={messages.response}
          loading={messages.loading}
          error={messages.error}
          pageIndex={messages.pageIndex}
          selectedId={selectedMessageId}
          onSelect={selectMessage}
          onPrevious={previousPage}
          onNext={nextPage}
        />
        <div className="min-w-0 border-t border-gray-200 lg:border-l lg:border-t-0 dark:border-gray-700">
          {selectedMessageId ? (
            <AdminEmailSelectedMessage key={selectedMessageId} mailboxId={mailbox.id} messageId={selectedMessageId} />
          ) : (
            <p data-test="admin-email-no-selection" className="p-6 text-sm opacity-60">
              Select an email to read its message.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminEmailReader;
